<template>
  <div class="satisfy-detail-container" style="width:100%;">
    <!-- 顶部导航栏 -->
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    
    <!-- 表格内容 -->
    <div class="table-wrapper">
      <table class="native-table">
        <tbody>
          <!-- 对课程满意度 -->
          <tr>
            <td rowspan="3" class="td-name">对课程满意度</td>
            <td class="td-aspect">启发性</td>
            <td class="td-score">{{inputForm.satisfy0}}</td>
          </tr>
          <tr>
            <td class="td-aspect">实用性</td>
            <td class="td-score">{{inputForm.satisfy1}}</td>
          </tr>
          <tr>
            <td class="td-aspect">推荐性</td>
            <td class="td-score">{{inputForm.satisfy2}}</td>
          </tr>
          
          <!-- 对讲师满意度 -->
          <tr>
            <td rowspan="5" class="td-name">对讲师满意度</td>
            <td class="td-aspect">生动性</td>
            <td class="td-score">{{inputForm.satisfy3}}</td>
          </tr>
          <tr>
            <td class="td-aspect">充分性</td>
            <td class="td-score">{{inputForm.satisfy4}}</td>
          </tr>
          <tr>
            <td class="td-aspect">亲和力</td>
            <td class="td-score">{{inputForm.satisfy5}}</td>
          </tr>
          <tr>
            <td class="td-aspect">逻辑性</td>
            <td class="td-score">{{inputForm.satisfy6}}</td>
          </tr>
          <tr>
            <td class="td-aspect">控制力</td>
            <td class="td-score">{{inputForm.satisfy7}}</td>
          </tr>
          
          <!-- 对组织部门满意度 -->
          <tr>
            <td rowspan="2" class="td-name">对组织部门满意度</td>
            <td class="td-aspect">安排合理性</td>
            <td class="td-score">{{inputForm.satisfy8}}</td>
          </tr>
          <tr>
            <td class="td-aspect">环境</td>
            <td class="td-score">{{inputForm.satisfy9}}</td>
          </tr>
          
          <!-- 总体满意度 -->
          <tr class="total-row">
            <td colspan="2" class="td-total">总体满意度</td>
            <td class="td-total-score">{{inputForm.satisfy}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "HrTrainSatisfyDetail",
  data() {
    return {
      inputForm: {
        satisfy0: '',
        satisfy1: '',
        satisfy2: '',
        satisfy3: '',
        satisfy4: '',
        satisfy5: '',
        satisfy6: '',
        satisfy7: '',
        satisfy8: '',
        satisfy9: '',
        satisfy: ''
      }
    };
  },
  created() {
    const query = this.$route.query;
    if (query.data) {
      try {
        this.inputForm = JSON.parse(query.data);
      } catch (e) {
        
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.satisfy-detail-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f7fa;
  box-sizing: border-box;
}

/* 顶部导航栏样式 */
.header-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
}

.back-btn {
  width: 64px !important;
  height: 34px;
  font-size: 13px;
  border: none;
}

.page-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  flex: 1;
}

.screen-btn {
  width: 64px;
  display: flex;
  justify-content: center;
}

/* 表格容器 */
.table-wrapper {
  width: 100%;
  padding: 58px 12px 12px;
  box-sizing: border-box;
  overflow-x: auto;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.native-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.td-name,
.td-aspect,
.td-score {
  padding: 10px 15px;
  border: 1px solid #ebeef5;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
}

/* 第一行的单元格需要上边框 */
.native-table tr:first-child .td-name,
.native-table tr:first-child .td-aspect,
.native-table tr:first-child .td-score {
  border-top: 1px solid #ebeef5;
}

/* 第一列的单元格需要左边框 */
.native-table tr td:first-child {
  border-left: 1px solid #ebeef5;
}

.td-name {
  background-color: #fff;
  color: #333;
  font-weight: 500;
  width: 180px;
}

.td-aspect {
  color: #333;
  text-align: left;
  padding-left: 20px;
  width: 150px;
}

.td-score {
  color: #333;
  font-weight: 600;
}

.total-row {
  background-color: transparent;
}

.td-total {
  padding: 12px 15px;
  border: 1px solid #dcdfe6;
  text-align: center;
  font-weight: 600;
  color: #333;
  font-size: 15px;
}

.td-total-score {
  padding: 12px 15px;
  border: 1px solid #dcdfe6;
  text-align: center;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

/* 响应式布局 */
@media screen and (max-width: 768px) {
  .header-nav {
    height: 48px;
  }
  
  .nav-content {
    padding: 0 10px;
  }
  
  .back-btn {
    width: 60px !important;
    height: 32px;
    font-size: 12px;
  }
  
  .screen-btn {
    width: 60px;
  }
  
  .page-title {
    font-size: 15px;
  }
  
  .table-wrapper {
    padding: 56px 10px 10px;
  }
  
  .native-table {
    font-size: 13px;
  }
  
  .td-name,
  .td-aspect,
  .td-score {
    padding: 8px 10px;
    border: 1px solid #ebeef5;
  }
  
  .td-name {
    width: 140px;
  }
  
  .td-aspect {
    padding-left: 15px;
  }
  
  .native-table tr td:first-child {
    border-left: 1px solid #ebeef5;
  }
}

@media screen and (max-width: 480px) {
  .header-nav {
    height: 46px;
  }
  
  .nav-content {
    padding: 0 8px;
  }
  
  .back-btn {
    width: 56px !important;
    height: 30px;
    font-size: 12px;
  }
  
  .screen-btn {
    width: 56px;
  }
  
  .page-title {
    font-size: 14px;
  }
  
  .table-wrapper {
    padding: 54px 8px 8px;
  }
  
  .native-table {
    font-size: 12px;
  }
  
  .td-name,
  .td-aspect,
  .td-score {
    padding: 6px 8px;
    border: 1px solid #ebeef5;
  }
  
  .td-name {
    width: 120px;
  }
  
  .native-table tr td:first-child {
    border-left: 1px solid #ebeef5;
  }
}
</style>
